import { useState, useEffect, useMemo, useRef } from "react";

const toHoursAndMinutes = (totalSeconds) => {
  const totalMinutes = Math.floor(totalSeconds / 60);

  const seconds = String(totalSeconds % 60).padStart(2, 0);
  const hours = String(Math.floor(totalMinutes / 60)).padStart(2, 0);
  const minutes = String(totalMinutes % 60).padStart(2, 0);

  return { h: hours, m: minutes, s: seconds };
};

const toSeconds = (hours, minutes, seconds) => {
  return hours * 3600 + minutes * 60 + seconds;
};

const useCountdown = (
  hours = 0,
  minutes = 0,
  seconds = 0,
  onCountdownFinished = () => {}
) => {
  const initialSeconds = useMemo(
    () => toSeconds(hours, minutes, seconds),
    [hours, minutes, seconds]
  );

  const [remainingSeconds, setRemainingSeconds] = useState(initialSeconds);
  const timerRef = useRef();

  useEffect(() => {
    if (remainingSeconds === 0) {
      stopTimer();
      onCountdownFinished();
    }
  }, [remainingSeconds]);

  const decreaseSecond = () => {
    if (!timerRef.current) {
      timerRef.current = setInterval(() => {
        setRemainingSeconds((prev) => --prev);
      }, 1000);
    }
  };

  const startTimer = () => {
    decreaseSecond();
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const resetTimer = () => {
    stopTimer();
    setRemainingSeconds(initialSeconds);
  };

  const { h, m, s } = toHoursAndMinutes(remainingSeconds);

  return {
    hours: h,
    minutes: m,
    seconds: s,
    startTimer,
    stopTimer,
    resetTimer,
  };
};

export default useCountdown;
